import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import {
  Plus,
  Trash2,
  Send,
  BookOpen,
  CheckSquare,
  Gamepad2,
  Code,
  List,
  Activity,
  RefreshCw,
  Clock,
  BarChart,
  Search,
  XCircle,
  Filter,
  Trophy,
} from "lucide-react";
import { styles } from "../utils/globalStyles";

export default function KelolaGamifikasi() {
  const [activeTab, setActiveTab] = useState("library"); // library, create, assign, monitor, progress
  const [loading, setLoading] = useState(false);

  // DATA UTAMA
  const [library, setLibrary] = useState([]);
  const [siswaList, setSiswaList] = useState([]);
  const [assignments, setAssignments] = useState([]);

  // --- STATE FILTER ---
  const [searchTerm, setSearchTerm] = useState("");
  const [filterKelas, setFilterKelas] = useState("");
  const [filterLevel, setFilterLevel] = useState("");

  const [searchLibrary, setSearchLibrary] = useState("");
  const [filterLevelLib, setFilterLevelLib] = useState("");

  const [searchMonitor, setSearchMonitor] = useState("");
  const [filterStatusMon, setFilterStatusMon] = useState("");
  const [filterKelasMon, setFilterKelasMon] = useState("");

  // FORM CREATE GAME
  const [inputMode, setInputMode] = useState("QUIZ");
  const [newGame, setNewGame] = useState({
    judul: "",
    deskripsi: "",
    reward_exp: 50,
    min_score: 70,
    rekomendasi_level: 1,
    durasi_menit: 0,
  });

  const [soalList, setSoalList] = useState([
    { tanya: "", opsi: ["", "", "", ""], kunci: "" },
  ]);
  const [customCode, setCustomCode] = useState(
    `\n<h2 style="text-align:center">Halo!</h2>\n<script>\n // window.parent.postMessage({ type: 'GAME_FINISH', score: 100, passed: true }, '*');\n</script>`
  );

  // FORM ASSIGN
  const [selectedQuestId, setSelectedQuestId] = useState("");
  const [selectedSiswaIds, setSelectedSiswaIds] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    setLoading(true);
    const { data: questData } = await supabase
      .from("library_quests")
      .select("*")
      .order("id", { ascending: false });
    setLibrary(questData || []);

    // UPDATE: Ambil juga total_exp dan urutkan berdasarkan EXP tertinggi (Leaderboard)
    const { data: siswaData } = await supabase
      .from("siswa")
      .select("id, nama_lengkap, kelas, level, total_exp")
      .order("total_exp", { ascending: false });
    setSiswaList(siswaData || []);

    const { data: assignData } = await supabase
      .from("siswa_quests")
      .select(
        `id, status, skor_terakhir, created_at, siswa ( nama_lengkap, kelas ), library_quests ( judul )`
      )
      .order("created_at", { ascending: false });
    setAssignments(assignData || []);
    setLoading(false);
  }

  // --- HELPER: HITUNG PROGRESS BAR ---
  const getProgressInfo = (currentLevel, totalExp) => {
    const nextLevel = currentLevel + 1;
    const targetExp = 50 * (nextLevel * nextLevel); // Rumus Kuadratik
    // Hindari pembagian nol
    if (targetExp === 0) return { percent: 0, target: 100 };

    const percent = Math.min(100, Math.round((totalExp / targetExp) * 100));
    return { percent, target: targetExp };
  };

  // --- LOGIC FILTERING ---

  // A. Filter Library
  const filteredLibrary = library.filter((q) => {
    const matchTitle = q.judul
      .toLowerCase()
      .includes(searchLibrary.toLowerCase());
    const matchLevel = filterLevelLib
      ? String(q.rekomendasi_level) === String(filterLevelLib)
      : true;
    return matchTitle && matchLevel;
  });

  // B. Filter Siswa (Assign & Progress Tab)
  const uniqueKelas = [...new Set(siswaList.map((s) => s.kelas))].sort();
  const uniqueLevel = [...new Set(siswaList.map((s) => s.level))].sort(
    (a, b) => a - b
  );

  const filteredSiswa = siswaList.filter((s) => {
    const matchName = s.nama_lengkap
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchKelas = filterKelas ? s.kelas === filterKelas : true;
    const matchLevel = filterLevel
      ? String(s.level) === String(filterLevel)
      : true;
    return matchName && matchKelas && matchLevel;
  });

  // C. Filter Monitoring
  const filteredAssignments = assignments.filter((a) => {
    const query = searchMonitor.toLowerCase();
    const matchName = a.siswa?.nama_lengkap.toLowerCase().includes(query);
    const matchGame = a.library_quests?.judul.toLowerCase().includes(query);
    const matchStatus = filterStatusMon ? a.status === filterStatusMon : true;
    const matchKelas = filterKelasMon
      ? a.siswa?.kelas === filterKelasMon
      : true;
    return (matchName || matchGame) && matchStatus && matchKelas;
  });

  // --- CRUD HELPERS ---
  const handleSelectAllFiltered = () => {
    const ids = filteredSiswa.map((s) => s.id);
    const gabungan = [...new Set([...selectedSiswaIds, ...ids])];
    setSelectedSiswaIds(gabungan);
  };

  const handleClearSelection = () => setSelectedSiswaIds([]);

  const handleAddSoal = () =>
    setSoalList([
      ...soalList,
      { tanya: "", opsi: ["", "", "", ""], kunci: "" },
    ]);

  const updateSoal = (index, field, value, idxOpsi = null) => {
    const updated = [...soalList];
    if (field === "opsi") updated[index].opsi[idxOpsi] = value;
    else updated[index][field] = value;
    setSoalList(updated);
  };

  const handleSaveGame = async () => {
    if (!newGame.judul) return alert("Judul wajib diisi!");
    let finalContent = [];
    if (inputMode === "QUIZ") {
      const isValid = soalList.every(
        (s) => s.tanya && s.kunci && s.opsi.includes(s.kunci)
      );
      if (!isValid) return alert("Cek kembali soal & kunci jawaban.");
      finalContent = soalList;
    } else {
      if (!customCode) return alert("Coding tidak boleh kosong!");
      finalContent = [{ type: "CUSTOM_HTML", html: customCode }];
    }

    setLoading(true);
    const { error } = await supabase
      .from("library_quests")
      .insert({ ...newGame, konten: finalContent });
    setLoading(false);
    if (error) alert("Gagal: " + error.message);
    else {
      alert("Game Berhasil Disimpan!");
      setNewGame({
        judul: "",
        deskripsi: "",
        reward_exp: 50,
        min_score: 70,
        rekomendasi_level: 1,
        durasi_menit: 0,
      });
      setSoalList([{ tanya: "", opsi: ["", "", "", ""], kunci: "" }]);
      setActiveTab("library");
      fetchData();
    }
  };

  const handleDeleteQuest = async (id) => {
    if (!confirm("Hapus game ini?")) return;
    await supabase.from("library_quests").delete().eq("id", id);
    fetchData();
  };

  const handleAssign = async () => {
    if (!selectedQuestId || selectedSiswaIds.length === 0)
      return alert("Pilih Game & Siswa!");
    setLoading(true);
    const payload = selectedSiswaIds.map((sid) => ({
      siswa_id: sid,
      quest_id: selectedQuestId,
      status: "PENDING",
      skor_terakhir: 0,
    }));
    const { error } = await supabase.from("siswa_quests").insert(payload);
    setLoading(false);
    if (error) alert("Gagal: " + error.message);
    else {
      alert("Misi Terkirim!");
      setSelectedSiswaIds([]);
      setActiveTab("monitor");
      fetchData();
    }
  };

  const handleToggleSiswa = (id) => {
    if (selectedSiswaIds.includes(id))
      setSelectedSiswaIds(selectedSiswaIds.filter((sid) => sid !== id));
    else setSelectedSiswaIds([...selectedSiswaIds, id]);
  };

  const handleDeleteAssignment = async (id) => {
    if (!confirm("Batalkan tugas ini?")) return;
    await supabase.from("siswa_quests").delete().eq("id", id);
    fetchData();
  };

  const handleResetAssignment = async (id) => {
    if (!confirm("Reset status tugas?")) return;
    await supabase
      .from("siswa_quests")
      .update({ status: "PENDING", skor_terakhir: 0 })
      .eq("id", id);
    fetchData();
  };

  return (
    <div style={styles.container}>
      <div
        style={{
          ...styles.headerHero,
          paddingBottom: "80px",
          borderRadius: "0 0 30px 30px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 15 }}>
          <div
            style={{
              background: "rgba(255,255,255,0.2)",
              padding: 10,
              borderRadius: 12,
            }}
          >
            <Gamepad2 size={28} color="white" />
          </div>
          <div>
            <h2 style={{ margin: 0, fontSize: "20px" }}>Kelola Gamifikasi</h2>
            <p style={{ margin: "5px 0 0 0", opacity: 0.9, fontSize: "13px" }}>
              Builder, Assign & Monitoring
            </p>
          </div>
        </div>
      </div>

      <div
        style={{
          padding: "0 20px",
          marginTop: "-50px",
          position: "relative",
          zIndex: 10,
        }}
      >
        {/* TAB NAV */}
        <div
          style={{
            background: "white",
            padding: "8px",
            borderRadius: "16px",
            display: "flex",
            gap: "5px",
            boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
            marginBottom: "25px",
            overflowX: "auto",
          }}
        >
          {[
            { id: "library", label: "Library", icon: <BookOpen size={14} /> },
            { id: "create", label: "Buat", icon: <Plus size={14} /> },
            { id: "assign", label: "Kirim", icon: <Send size={14} /> },
            { id: "monitor", label: "Monitor", icon: <Activity size={14} /> },
            { id: "progress", label: "Progress", icon: <Trophy size={14} /> },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                flex: 1,
                minWidth: 80,
                padding: "10px",
                border: "none",
                background: activeTab === tab.id ? "#2563EB" : "transparent",
                color: activeTab === tab.id ? "white" : "#64748B",
                fontWeight: "600",
                fontSize: "12px",
                borderRadius: "10px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "4px",
              }}
            >
              {tab.icon} {tab.label}
            </button>
          ))}
        </div>

        {/* --- TAB 1: LIBRARY --- */}
        {activeTab === "library" && (
          <div>
            <div
              style={{
                background: "white",
                padding: 10,
                borderRadius: 12,
                marginBottom: 15,
                display: "flex",
                gap: 10,
                boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
              }}
            >
              <div
                style={{
                  flex: 2,
                  display: "flex",
                  alignItems: "center",
                  background: "#F1F5F9",
                  padding: "5px 10px",
                  borderRadius: 8,
                }}
              >
                <Search size={16} color="#94A3B8" />
                <input
                  placeholder="Cari judul game..."
                  style={{
                    border: "none",
                    background: "transparent",
                    outline: "none",
                    padding: 5,
                    width: "100%",
                    fontSize: 13,
                  }}
                  value={searchLibrary}
                  onChange={(e) => setSearchLibrary(e.target.value)}
                />
              </div>
              <div style={{ flex: 1 }}>
                <select
                  style={{
                    width: "100%",
                    padding: 8,
                    borderRadius: 8,
                    border: "1px solid #E2E8F0",
                    fontSize: 12,
                    background: "#F1F5F9",
                  }}
                  value={filterLevelLib}
                  onChange={(e) => setFilterLevelLib(e.target.value)}
                >
                  <option value="">Semua Level</option>
                  {[1, 2, 3, 4, 5, 6].map((l) => (
                    <option key={l} value={l}>
                      Level {l}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div style={{ display: "grid", gap: "15px" }}>
              {filteredLibrary.length === 0 ? (
                <p
                  style={{
                    textAlign: "center",
                    color: "#94A3B8",
                    fontSize: 13,
                  }}
                >
                  Game tidak ditemukan.
                </p>
              ) : (
                filteredLibrary.map((q) => {
                  const isCustom =
                    q.konten &&
                    q.konten[0] &&
                    q.konten[0].type === "CUSTOM_HTML";
                  return (
                    <div key={q.id} style={styles.compactCard}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "start",
                        }}
                      >
                        <div>
                          <div
                            style={{
                              fontWeight: "bold",
                              fontSize: "16px",
                              color: "#1E293B",
                            }}
                          >
                            {q.judul}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "8px",
                              fontSize: "11px",
                              color: "#64748B",
                              marginTop: 5,
                            }}
                          >
                            <span
                              style={{
                                background: "#FEF3C7",
                                color: "#D97706",
                                padding: "2px 6px",
                                borderRadius: "4px",
                                fontWeight: "bold",
                              }}
                            >
                              {q.reward_exp} EXP
                            </span>
                            <span
                              style={{
                                background: "#DCFCE7",
                                color: "#166534",
                                padding: "2px 6px",
                                borderRadius: "4px",
                              }}
                            >
                              <BarChart size={10} /> Lv.{q.rekomendasi_level}
                            </span>
                            {q.durasi_menit > 0 && (
                              <span
                                style={{
                                  background: "#FFE4E6",
                                  color: "#E11D48",
                                  padding: "2px 6px",
                                  borderRadius: "4px",
                                }}
                              >
                                <Clock size={10} /> {q.durasi_menit}m
                              </span>
                            )}
                            {isCustom ? (
                              <span
                                style={{
                                  background: "#F3E8FF",
                                  color: "#7C3AED",
                                  padding: "2px 6px",
                                  borderRadius: "4px",
                                }}
                              >
                                <Code size={10} /> Code
                              </span>
                            ) : (
                              <span
                                style={{
                                  background: "#E0F2FE",
                                  color: "#0284C7",
                                  padding: "2px 6px",
                                  borderRadius: "4px",
                                }}
                              >
                                <List size={10} /> Quiz
                              </span>
                            )}
                          </div>
                        </div>
                        <button
                          onClick={() => handleDeleteQuest(q.id)}
                          style={{
                            background: "#FEF2F2",
                            color: "#EF4444",
                            border: "none",
                            padding: "8px",
                            borderRadius: "8px",
                            cursor: "pointer",
                          }}
                        >
                          <Trash2 size={18} />
                        </button>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        )}

        {/* --- TAB 2: CREATE --- */}
        {activeTab === "create" && (
          <div
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "16px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
            }}
          >
            <input
              style={styles.inputField}
              placeholder="Judul Game"
              value={newGame.judul}
              onChange={(e) =>
                setNewGame({ ...newGame, judul: e.target.value })
              }
            />
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 15,
                marginBottom: 15,
              }}
            >
              <div>
                <label
                  style={{ fontSize: 11, fontWeight: "bold", color: "#64748B" }}
                >
                  Reward EXP
                </label>
                <input
                  type="number"
                  style={styles.inputField}
                  value={newGame.reward_exp}
                  onChange={(e) =>
                    setNewGame({
                      ...newGame,
                      reward_exp: parseInt(e.target.value),
                    })
                  }
                />
              </div>
              <div>
                <label
                  style={{ fontSize: 11, fontWeight: "bold", color: "#64748B" }}
                >
                  Min. Nilai
                </label>
                <input
                  type="number"
                  style={styles.inputField}
                  value={newGame.min_score}
                  onChange={(e) =>
                    setNewGame({
                      ...newGame,
                      min_score: parseInt(e.target.value),
                    })
                  }
                />
              </div>
              <div>
                <label
                  style={{ fontSize: 11, fontWeight: "bold", color: "#64748B" }}
                >
                  Rec. Level
                </label>
                <input
                  type="number"
                  style={styles.inputField}
                  value={newGame.rekomendasi_level}
                  onChange={(e) =>
                    setNewGame({
                      ...newGame,
                      rekomendasi_level: parseInt(e.target.value),
                    })
                  }
                />
              </div>
              <div>
                <label
                  style={{ fontSize: 11, fontWeight: "bold", color: "#64748B" }}
                >
                  Timer (Min)
                </label>
                <input
                  type="number"
                  placeholder="0 = Bebas"
                  style={styles.inputField}
                  value={newGame.durasi_menit}
                  onChange={(e) =>
                    setNewGame({
                      ...newGame,
                      durasi_menit: parseInt(e.target.value),
                    })
                  }
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                background: "#F1F5F9",
                padding: 4,
                borderRadius: 8,
                marginBottom: 20,
              }}
            >
              <button
                onClick={() => setInputMode("QUIZ")}
                style={{
                  flex: 1,
                  padding: 8,
                  border: "none",
                  borderRadius: 6,
                  background: inputMode === "QUIZ" ? "white" : "transparent",
                  fontWeight: "bold",
                  color: inputMode === "QUIZ" ? "#2563EB" : "#64748B",
                  cursor: "pointer",
                }}
              >
                Quiz Builder
              </button>
              <button
                onClick={() => setInputMode("CUSTOM")}
                style={{
                  flex: 1,
                  padding: 8,
                  border: "none",
                  borderRadius: 6,
                  background: inputMode === "CUSTOM" ? "white" : "transparent",
                  fontWeight: "bold",
                  color: inputMode === "CUSTOM" ? "#2563EB" : "#64748B",
                  cursor: "pointer",
                }}
              >
                Manual Code
              </button>
            </div>

            {inputMode === "QUIZ" ? (
              <div>
                {soalList.map((soal, i) => (
                  <div
                    key={i}
                    style={{
                      background: "#F8FAFC",
                      padding: "15px",
                      borderRadius: "12px",
                      marginBottom: "15px",
                      border: "1px solid #E2E8F0",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: "13px",
                        color: "#2563EB",
                        marginBottom: "8px",
                      }}
                    >
                      Soal #{i + 1}
                    </div>
                    <input
                      style={{ ...styles.inputField, marginBottom: "12px" }}
                      placeholder="Pertanyaan..."
                      value={soal.tanya}
                      onChange={(e) => updateSoal(i, "tanya", e.target.value)}
                    />
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "10px",
                      }}
                    >
                      {soal.opsi.map((opt, idxOpt) => (
                        <input
                          key={idxOpt}
                          style={styles.inputField}
                          placeholder={`Opsi ${idxOpt + 1}`}
                          value={opt}
                          onChange={(e) =>
                            updateSoal(i, "opsi", e.target.value, idxOpt)
                          }
                        />
                      ))}
                    </div>
                    <input
                      style={{
                        ...styles.inputField,
                        marginTop: 10,
                        border: "1px solid #22C55E",
                        background: "#F0FDF4",
                      }}
                      placeholder="Jawaban Benar..."
                      value={soal.kunci}
                      onChange={(e) => updateSoal(i, "kunci", e.target.value)}
                    />
                  </div>
                ))}
                <button
                  onClick={handleAddSoal}
                  style={{
                    width: "100%",
                    padding: "10px",
                    background: "#F1F5F9",
                    border: "1px dashed #94A3B8",
                    borderRadius: "8px",
                    cursor: "pointer",
                    color: "#475569",
                    fontWeight: "bold",
                    marginBottom: 20,
                  }}
                >
                  + Tambah Soal
                </button>
              </div>
            ) : (
              <div style={{ marginBottom: 20 }}>
                <textarea
                  value={customCode}
                  onChange={(e) => setCustomCode(e.target.value)}
                  style={{
                    width: "100%",
                    height: "300px",
                    background: "#0F172A",
                    color: "#00E0FF",
                    fontFamily: "monospace",
                    padding: 15,
                    borderRadius: "8px",
                    border: "none",
                    resize: "vertical",
                  }}
                />
              </div>
            )}
            <button
              onClick={handleSaveGame}
              disabled={loading}
              style={styles.primaryBtn}
            >
              {loading ? "Saving..." : "SIMPAN GAME"}
            </button>
          </div>
        )}

        {/* --- TAB 3: ASSIGN --- */}
        {activeTab === "assign" && (
          <div
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "16px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
            }}
          >
            <h3 style={{ marginTop: 0, fontSize: "16px", color: "#334155" }}>
              1. Pilih Game
            </h3>
            <select
              style={styles.inputField}
              onChange={(e) => setSelectedQuestId(e.target.value)}
              value={selectedQuestId}
            >
              <option value="">-- Pilih Game --</option>
              {library.map((q) => (
                <option key={q.id} value={q.id}>
                  {q.judul} (Lv.{q.rekomendasi_level})
                </option>
              ))}
            </select>

            <h3
              style={{
                marginTop: "20px",
                fontSize: "16px",
                color: "#334155",
                display: "flex",
                alignItems: "center",
                gap: 5,
              }}
            >
              2. Pilih Siswa{" "}
              <span
                style={{
                  fontSize: 12,
                  background: "#2563EB",
                  color: "white",
                  padding: "2px 8px",
                  borderRadius: 10,
                }}
              >
                Terpilih: {selectedSiswaIds.length}
              </span>
            </h3>

            <div
              style={{
                background: "#F1F5F9",
                padding: 10,
                borderRadius: 12,
                marginBottom: 10,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "white",
                  padding: "5px 10px",
                  borderRadius: 8,
                  border: "1px solid #CBD5E1",
                  marginBottom: 10,
                }}
              >
                <Search size={16} color="#94A3B8" />
                <input
                  placeholder="Cari nama siswa..."
                  style={{
                    border: "none",
                    outline: "none",
                    padding: 5,
                    width: "100%",
                    fontSize: 13,
                  }}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                <select
                  style={{
                    flex: 1,
                    padding: 8,
                    borderRadius: 8,
                    border: "1px solid #CBD5E1",
                    fontSize: 12,
                  }}
                  value={filterKelas}
                  onChange={(e) => setFilterKelas(e.target.value)}
                >
                  <option value="">Semua Kelas</option>
                  {uniqueKelas.map((k) => (
                    <option key={k} value={k}>
                      Kelas {k}
                    </option>
                  ))}
                </select>
                <select
                  style={{
                    flex: 1,
                    padding: 8,
                    borderRadius: 8,
                    border: "1px solid #CBD5E1",
                    fontSize: 12,
                  }}
                  value={filterLevel}
                  onChange={(e) => setFilterLevel(e.target.value)}
                >
                  <option value="">Semua Level</option>
                  {uniqueLevel.map((l) => (
                    <option key={l} value={l}>
                      Level {l}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
                marginBottom: 10,
              }}
            >
              {selectedSiswaIds.length > 0 && (
                <button
                  onClick={handleClearSelection}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "#EF4444",
                    fontSize: 11,
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                  }}
                >
                  <XCircle size={12} /> Reset Pilihan
                </button>
              )}
              <button
                onClick={handleSelectAllFiltered}
                style={{
                  background: "#DBEAFE",
                  border: "none",
                  color: "#2563EB",
                  padding: "4px 10px",
                  borderRadius: 4,
                  fontSize: 11,
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Pilih Semua ({filteredSiswa.length})
              </button>
            </div>

            <div
              style={{
                maxHeight: "300px",
                overflowY: "auto",
                border: "1px solid #E2E8F0",
                borderRadius: 8,
              }}
            >
              {filteredSiswa.length === 0 ? (
                <div
                  style={{
                    padding: 20,
                    textAlign: "center",
                    color: "#94A3B8",
                    fontSize: 13,
                  }}
                >
                  Tidak ada siswa ditemukan.
                </div>
              ) : (
                filteredSiswa.map((s) => (
                  <div
                    key={s.id}
                    onClick={() => handleToggleSiswa(s.id)}
                    style={{
                      padding: "10px",
                      borderBottom: "1px solid #eee",
                      cursor: "pointer",
                      background: selectedSiswaIds.includes(s.id)
                        ? "#EFF6FF"
                        : "white",
                      display: "flex",
                      gap: 10,
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        width: 18,
                        height: 18,
                        border: selectedSiswaIds.includes(s.id)
                          ? "none"
                          : "2px solid #ccc",
                        background: selectedSiswaIds.includes(s.id)
                          ? "#2563EB"
                          : "transparent",
                        borderRadius: 4,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {selectedSiswaIds.includes(s.id) && (
                        <CheckSquare size={14} color="white" />
                      )}
                    </div>
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 500 }}>
                        {s.nama_lengkap}
                      </div>
                      <div style={{ fontSize: 11, color: "#64748B" }}>
                        Kelas {s.kelas} • Lv.{s.level}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
            <button
              onClick={handleAssign}
              disabled={loading}
              style={{ ...styles.primaryBtn, marginTop: 20 }}
            >
              KIRIM MISI
            </button>
          </div>
        )}

        {/* --- TAB 4: MONITORING --- */}
        {activeTab === "monitor" && (
          <div
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "16px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 15,
              }}
            >
              <h3 style={{ marginTop: 0, fontSize: "16px", color: "#334155" }}>
                Monitoring
              </h3>
              <div style={{ fontSize: 12, color: "#64748B" }}>
                Tampil: <b>{filteredAssignments.length}</b>
              </div>
            </div>

            {/* FILTER MONITORING */}
            <div
              style={{
                background: "#F8FAFC",
                padding: 10,
                borderRadius: 12,
                marginBottom: 15,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "white",
                  padding: "5px 10px",
                  borderRadius: 8,
                  border: "1px solid #E2E8F0",
                  marginBottom: 10,
                }}
              >
                <Search size={16} color="#94A3B8" />
                <input
                  placeholder="Cari siswa / judul game..."
                  style={{
                    border: "none",
                    outline: "none",
                    padding: 5,
                    width: "100%",
                    fontSize: 13,
                  }}
                  value={searchMonitor}
                  onChange={(e) => setSearchMonitor(e.target.value)}
                />
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                <select
                  style={{
                    flex: 1,
                    padding: 8,
                    borderRadius: 8,
                    border: "1px solid #E2E8F0",
                    fontSize: 12,
                  }}
                  value={filterStatusMon}
                  onChange={(e) => setFilterStatusMon(e.target.value)}
                >
                  <option value="">Semua Status</option>
                  <option value="PENDING">PENDING</option>
                  <option value="SELESAI">SELESAI</option>
                </select>
                <select
                  style={{
                    flex: 1,
                    padding: 8,
                    borderRadius: 8,
                    border: "1px solid #E2E8F0",
                    fontSize: 12,
                  }}
                  value={filterKelasMon}
                  onChange={(e) => setFilterKelasMon(e.target.value)}
                >
                  <option value="">Semua Kelas</option>
                  {uniqueKelas.map((k) => (
                    <option key={k} value={k}>
                      Kelas {k}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {filteredAssignments.length === 0 ? (
              <p
                style={{ color: "#94A3B8", textAlign: "center", fontSize: 13 }}
              >
                Data tidak ditemukan.
              </p>
            ) : (
              <div
                style={{
                  display: "grid",
                  gap: 10,
                  maxHeight: 400,
                  overflowY: "auto",
                }}
              >
                {filteredAssignments.map((item) => (
                  <div
                    key={item.id}
                    style={{
                      border: "1px solid #E2E8F0",
                      padding: 12,
                      borderRadius: 8,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          fontWeight: "bold",
                          color: "#1E293B",
                          fontSize: 13,
                        }}
                      >
                        {item.library_quests?.judul}
                      </div>
                      <div style={{ fontSize: 12, color: "#64748B" }}>
                        {item.siswa?.nama_lengkap} (Kls {item.siswa?.kelas})
                      </div>
                      <div style={{ fontSize: 11, marginTop: 4 }}>
                        Status:{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            color:
                              item.status === "SELESAI" ? "#16A34A" : "#F59E0B",
                          }}
                        >
                          {item.status}
                        </span>
                      </div>
                    </div>
                    <div style={{ display: "flex", gap: 5 }}>
                      <button
                        title="Reset"
                        onClick={() => handleResetAssignment(item.id)}
                        style={{
                          background: "#EFF6FF",
                          color: "#2563EB",
                          border: "none",
                          padding: 8,
                          borderRadius: 6,
                          cursor: "pointer",
                        }}
                      >
                        <RefreshCw size={16} />
                      </button>
                      <button
                        title="Hapus"
                        onClick={() => handleDeleteAssignment(item.id)}
                        style={{
                          background: "#FEF2F2",
                          color: "#EF4444",
                          border: "none",
                          padding: 8,
                          borderRadius: 6,
                          cursor: "pointer",
                        }}
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* --- TAB 5: PROGRESS (BARU!) --- */}
        {activeTab === "progress" && (
          <div
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "16px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
            }}
          >
            <h3 style={{ marginTop: 0, fontSize: "16px", color: "#334155" }}>
              Progress Siswa
            </h3>

            {/* FILTER AREA (Reuse Logic dari Assign) */}
            <div
              style={{
                background: "#F1F5F9",
                padding: 10,
                borderRadius: 12,
                marginBottom: 15,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "white",
                  padding: "5px 10px",
                  borderRadius: 8,
                  border: "1px solid #CBD5E1",
                  marginBottom: 10,
                }}
              >
                <Search size={16} color="#94A3B8" />
                <input
                  placeholder="Cari nama siswa..."
                  style={{
                    border: "none",
                    outline: "none",
                    padding: 5,
                    width: "100%",
                    fontSize: 13,
                  }}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                <select
                  style={{
                    flex: 1,
                    padding: 8,
                    borderRadius: 8,
                    border: "1px solid #CBD5E1",
                    fontSize: 12,
                  }}
                  value={filterKelas}
                  onChange={(e) => setFilterKelas(e.target.value)}
                >
                  <option value="">Semua Kelas</option>
                  {uniqueKelas.map((k) => (
                    <option key={k} value={k}>
                      Kelas {k}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div style={{ display: "grid", gap: 10 }}>
              {filteredSiswa.map((s) => {
                const { percent, target } = getProgressInfo(
                  s.level,
                  s.total_exp
                );
                return (
                  <div
                    key={s.id}
                    style={{
                      border: "1px solid #E2E8F0",
                      padding: 12,
                      borderRadius: 12,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: 5,
                      }}
                    >
                      <div style={{ fontWeight: "bold", fontSize: 13 }}>
                        {s.nama_lengkap}
                      </div>
                      <div
                        style={{
                          fontSize: 12,
                          fontWeight: "bold",
                          color: "#D97706",
                        }}
                      >
                        Lv.{s.level}
                      </div>
                    </div>

                    {/* PROGRESS BAR VISUAL */}
                    <div
                      style={{
                        background: "#F1F5F9",
                        height: 8,
                        borderRadius: 4,
                        overflow: "hidden",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          width: `${percent}%`,
                          background: "#F59E0B",
                          height: "100%",
                        }}
                      ></div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 5,
                        fontSize: 10,
                        color: "#64748B",
                      }}
                    >
                      <span>{s.total_exp} EXP</span>
                      <span>Target: {target} EXP</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
